import { useState, useEffect } from 'react';
import Joyride, { Step } from 'react-joyride';

const steps: Step[] = [
  {
    target: '.name-search-input',
    content: 'Start by entering a name to discover its meaning and popularity',
    disableBeacon: true,
  },
  {
    target: '.gender-filters',
    content: 'Filter names by gender to narrow down your search',
  },
  {
    target: '.alphabet-filters',
    content: 'Click on a letter to see names starting with that alphabet',
  },
  {
    target: '.name-matches-tool',
    content: 'Find out which names match well with yours!',
  },
  {
    target: '.quotes-section',
    content: 'Explore inspiring Nepali quotes categorized by themes',
  },
];

export default function Tutorial() {
  const [run, setRun] = useState(false);

  useEffect(() => {
    const hasSeenTutorial = localStorage.getItem('hasSeenTutorial');
    if (!hasSeenTutorial) {
      setRun(true);
    }
  }, []);

  const handleJoyrideCallback = (data: any) => {
    const { status } = data;
    if (status === 'finished') {
      localStorage.setItem('hasSeenTutorial', 'true');
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      showProgress
      styles={{
        options: {
          primaryColor: '#9333ea',
          textColor: '#374151',
        },
      }}
      callback={handleJoyrideCallback}
    />
  );
}